export default {
  PERF_DATA_LOADING: '@PERF_DATA_LOADING',
  PERF_DATA_ERROR: '@PERF_DATA_ERROR',
  PERFORMANCE_DATA_SUCCESS: '@PERF_PERFORMANCE_DATA_SUCCESS',
  SALES_DATA_SUCCESS: '@PERF_SALES_DATA_SUCCESS',
  PERFORMANCE_DATA_RESET: '@PERF_DATA_RESET',

  TRANSACTION_DETAILS_LOADING: '@PERF_TRANSACTION_DETAILS_LOADING',
  TRANSACTION_DETAILS_ERROR: '@PERF_TRANSACTION_DETAILS_ERROR',
  TRANSACTION_DETAILS_SUCCESS: '@PERF_TRANSACTION_DETAILS_SUCCESS',
  RESET_TRANSACTION_DETAILS: '@PERF_RESET_TRANSACTION_DETAILS',

  TRANSACTION_DETAILS_V2_LOADING: '@PERF_TRANSACTION_DETAILS_V2_LOADING',
  TRANSACTION_DETAILS_V2_ERROR: '@PERF_TRANSACTION_DETAILS_V2_ERROR',
  TRANSACTION_DETAILS_V2_SUCCESS: '@PERF_TRANSACTION_DETAILS_V2_SUCCESS',
  RESET_TRANSACTION_DETAILS_V2: '@PERF_RESET_TRANSACTION_DETAILS_V2',

  PERF_CLIENT_DETAILS_LOADING: '@PERF_CLIENT_DETAILS_LOADING',
  PERF_CLIENT_DETAILS_ERROR: '@PERF_CLIENT_DETAILS_ERROR',
  PERF_CLIENT_DETAILS_SUCCESS: '@PERF_CLIENT_DETAILS_SUCCESS',
  PERF_RESET_CLIENT_DETAILS: '@PERF_RESET_CLIENT_DETAILS',

  RESET_ASSOCIATE_SALES: '@PERF_RESET_ASSOCIATE_SALES',

  TODAYS_SALES_LOADING: '@TODAYS_SALES_LOADING',
  TODAYS_SALES_ERROR: '@TODAYS_SALES_ERROR',
  TODAYS_SALES_SUCCESS: '@TODAYS_SALES_SUCCESS',

  MANAGER_SALES_LOADING: '@PERF_MANAGER_SALES_LOADING',
  MANAGER_SALES_ERROR: '@PERF_MANAGER_SALES_ERROR',
  MANAGER_SALES_SUCCESS: '@PERF_MANAGER_SALES_SUCCESS',
  MANAGER_SALES_CLEAR: '@PERF_MANAGER_SALES_CLEAR',

  MANAGER_SALES_TREE_LOADING: '@PERF_MANAGER_SALES_TREE_LOADING',
  MANAGER_SALES_TREE_ERROR: '@PERF_MANAGER_SALES_TREE_ERROR',
  MANAGER_SALES_TREE_SUCCESS: '@PERF_MANAGER_SALES_TREE_SUCCESS',
  MANAGER_SALES_TREE_CLEAR: '@PERF_MANAGER_SALES_TREE_CLEAR',
  MANAGER_SALES_TREE_SAVE_STATE: '@PERF_MANAGER_SALES_TREE_SAVE_STATE',
  MANAGER_SALES_TREE_CLEAR_CACHE: '@PERF_MANAGER_SALES_TREE_CLEAR_CACHE',
  MANAGER_SALES_TREE_RESTORE: '@PERF_MANAGER_SALES_TREE_RESTORE',

  PERF_FILTER_OPTIONS_LOADING: '@PERF_FILTER_OPTIONS_LOADING',
  PERF_FILTER_OPTIONS_SUCCESS: '@PERF_FILTER_OPTIONS_SUCCESS',
  PERF_FILTER_OPTIONS_ERROR: '@PERF_FILTER_OPTIONS_ERROR',

  PERF_SET_PERFORMANCE_FILTERS: '@PERF_SET_PERFORMANCE_FILTERS',
  PERF_CLEAR_PERFORMANCE_FILTERS: '@PERF_CLEAR_PERFORMANCE_FILTERS',
  PERF_SET_FILTER_LABELS: '@PERF_SET_FILTER_LABELS',

  MANAGER_SALES_DETAILS_LOADING: '@PERF_MANAGER_SALES_DETAILS_LOADING',
  MANAGER_SALES_DETAILS_ERROR: '@PERF_MANAGER_SALES_DETAILS_ERROR',
  MANAGER_SALES_DETAILS_SUCCESS: '@PERF_MANAGER_SALES_DETAILS_SUCCESS',

  ASSOCIATE_ENGAGEMENTS_LOADING: '@PERF_ENGAGEMENTS_LOADING',
  ASSOCIATE_ENGAGEMENTS_SUCCESS: '@PERF_ENGAGEMENTS_SUCCESS',
  ASSOCIATE_ENGAGEMENTS_ERROR: '@PERF_ENGAGEMENTS_ERROR',

  ASSOCIATE_REMINDERS_LOADING: '@ASSOCIATE_REMINDERS_LOADING',
  ASSOCIATE_REMINDERS_SUCCESS: '@ASSOCIATE_REMINDERS_SUCCESS',
  ASSOCIATE_REMINDERS_ERROR: '@ASSOCIATE_REMINDERS_ERROR',

  ASSOCIATE_REMINDER_UPDATE_SUCCESS: '@ASSOCIATE_REMINDER_UPDATE_SUCCESS',
  ASSOCIATE_REMINDERS_COUNT_SUCCESS: '@ASSOCIATE_REMINDERS_COUNT_SUCCESS',

  ASSOCIATE_MY_SCORECARD_LOADING: '@PERF_ASSOCIATE_MY_SCORECARD_LOADING',
  ASSOCIATE_MY_SCORECARD_SUCCESS: '@PERF_ASSOCIATE_MY_SCORECARD_SUCCESS',
  ASSOCIATE_MY_SCORECARD_ERROR: '@PERF_ASSOCIATE_MY_SCORECARD_ERROR',

  ASSOCIATE_EXP_SCORECARD_LOADING: '@PERF_ASSOCIATE_EXP_SCORECARD_LOADING',
  ASSOCIATE_EXP_SCORECARD_ERROR: '@PERF_ASSOCIATE_EXP_SCORECARD_ERROR',
  ASSOCIATE_EXP_SCORECARD_CLEAR: '@PERF_ASSOCIATE_EXP_SCORECARD_CLEAR',
  ASSOCIATE_EXP_SCORECARD_SUCCESS: '@PERF_ASSOCIATE_EXP_SCORECARD_SUCCESS',

  PERF_SET_PERFORMANCE_DATE_FILTER: '@PERF_SET_PERFORMANCE_DATE_FILTER',
  PERF_CLEAR_PERFORMANCE_DATE_FILTER: '@PERF_CLEAR_PERFORMANCE_DATE_FILTER',

  CALENDAR_RANGE_SET_DATE_RANGE: '@CALENDAR_RANGE_SET_DATE_RANGE',
  CALENDAR_RANGE_RESET_DATE_RANGE: '@CALENDAR_RANGE_RESET_DATE_RANGE',

  MANAGER_DIVISIONS_PER_DESIGNER_LOADING: '@PERF_MANAGER_DIVISIONS_PER_DESIGNER_LOADING',
  MANAGER_DIVISIONS_PER_DESIGNER_SUCCESS: '@PERF_MANAGER_DIVISIONS_PER_DESIGNER_SUCCESS',
  MANAGER_DIVISIONS_PER_DESIGNER_ERROR: '@PERF_MANAGER_DIVISIONS_PER_DESIGNER_ERROR',

  MANAGER_GROUPS_PER_DESIGNER_LOADING: '@PERF_MANAGER_GROUPS_PER_DESIGNER_LOADING',
  MANAGER_GROUPS_PER_DESIGNER_SUCCESS: '@PERF_MANAGER_GROUPS_PER_DESIGNER_SUCCESS',
  MANAGER_GROUPS_PER_DESIGNER_ERROR: '@PERF_MANAGER_GROUPS_PER_DESIGNER_ERROR',

  MANAGER_CLIENT_CONNECTS_LOADING: '@PERF_MANAGER_CLIENT_CONNECTS_LOADING',
  MANAGER_CLIENT_CONNECTS_SUCCESS: '@PERF_MANAGER_CLIENT_CONNECTS_SUCCESS',
  MANAGER_CLIENT_CONNECTS_ERROR: '@PERF_MANAGER_CLIENT_CONNECTS_ERROR',
  MANAGER_CLIENT_CONNECTS_CLEAR: '@PERF_MANAGER_CLIENT_CONNECTS_CLEAR',

  MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS: '@PERF_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS',
  MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING: '@PERF_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING',
  MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR: '@PERF_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR',

  MANAGER_CLIENT_CONNECTS_DETAILS_LOADING: '@PERF_MANAGER_CLIENT_CONNECTS_DETAILS_LOADING',
  MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS: '@PERF_MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS',
  MANAGER_CLIENT_CONNECTS_DETAILS_ERROR: '@PERF_MANAGER_CLIENT_CONNECTS_DETAILS_ERROR',

  MANAGER_ASSOCIATE_SALES_METRICS_LOADING: '@PERF_MANAGER_ASSOCIATE_SALES_METRICS_LOADING',
  MANAGER_ASSOCIATE_SALES_METRICS_SUCCESS: '@PERF_MANAGER_ASSOCIATE_SALES_METRICS_SUCCESS',
  MANAGER_ASSOCIATE_SALES_METRICS_ERROR: '@PERF_MANAGER_ASSOCIATE_SALES_METRICS_ERROR',
  MANAGER_ASSOCIATE_SALES_METRICS_CLEAR: '@PERF_MANAGER_ASSOCIATE_SALES_METRICS_CLEAR',

  TODAYS_SALES_FOR_STYLIST_MANAGER_LOADING: '@PERF_TODAYS_SALES_FOR_STYLIST_MANAGER_LOADING',
  TODAYS_SALES_FOR_STYLIST_MANAGER_SUCCESS: '@PERF_TODAYS_SALES_FOR_STYLIST_MANAGER_SUCCESS',
  TODAYS_SALES_FOR_STYLIST_MANAGER_ERROR: '@PERF_TODAYS_SALES_FOR_STYLIST_MANAGER_ERROR',

  STYLIST_MANAGER_SALES_LOADING: '@PERF_STYLIST_MANAGER_SALES_LOADING',
  STYLIST_MANAGER_SALES_SUCCESS: '@PERF_STYLIST_MANAGER_SALES_SUCCESS',
  STYLIST_MANAGER_SALES_ERROR: '@PERF_STYLIST_MANAGER_SALES_ERROR',

  CLEAR_STYLIST_MANAGER_SALES: '@PERF_CLEAR_STYLIST_MANAGER_SALES',

  STYLIST_MANAGER_SALES_SA_SEARCH_TERM: '@PERF_STYLIST_MANAGER_SALES_SA_SEARCH_TERM',
  STYLIST_MANAGER_SALES_SA_SEARCH_TERM_CLEAR: '@PERF_STYLIST_MANAGER_SALES_SA_SEARCH_TERM_CLEAR',

  STYLIST_MANAGER_SALES_SET_IS_BACK_FROM_ASSOCIATE_PERF_HOME_PAGE:
    '@PERF_STYLIST_MANAGER_SALES_SET_IS_BACK_FROM_ASSOCIATE_PERF_HOME_PAGE',
  STYLIST_MANAGER_SALES_SET_IS_BACK_FROM_ASSOCIATE_PERF_HOME_PAGE_CLEAR:
    '@PERF_STYLIST_MANAGER_SALES_SET_IS_BACK_FROM_ASSOCIATE_PERF_HOME_PAGE_CLEAR',

  STYLIST_MANAGER_CLIENT_CONNECTS_LOADING: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_LOADING',
  STYLIST_MANAGER_CLIENT_CONNECTS_SUCCESS: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_SUCCESS',
  STYLIST_MANAGER_CLIENT_CONNECTS_ERROR: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_ERROR',

  STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_LOADING: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_LOADING',
  STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_SUCCESS',
  STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_ERROR: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_ERROR',
  STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_CLEAR: '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_DETAILS_CLEAR',

  STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING:
    '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_LOADING',
  STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS:
    '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_SUCCESS',
  STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_ERROR:
    '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_ERROR',
  STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR:
    '@PERF_STYLIST_MANAGER_CLIENT_CONNECTS_SELECT_ASSOCIATE_CLEAR',
  PERF_ASSOCIATE_DATA_LOADING: '@PERF_ASSOCIATE_DATA_LOADING',
  PERF_ASSOCIATE_DATA_SUCCESS: '@PERF_ASSOCIATE_DATA_SUCCESS',
  PERF_ASSOCIATE_DATA_ERROR: '@PERF_ASSOCIATE_DATA_ERROR',
  PERF_RESET_ASSOCIATE_DATA: '@PERF_RESET_ASSOCIATE_DATA',
};
